import {AfterViewInit, Component, OnInit} from "@angular/core";
import {DialogComponent} from '../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../ng2-bootstrap-modal/dialog.service';
import * as fromStore from "../../store";
import {Store} from "@ngrx/store";
import {filter, first, switchMap} from "rxjs/operators";
import {GoogleAnalyticsService} from "../../shared/services/google-analytics/google-analytics.service";
import {Router} from "@angular/router";
import {TypeUtils} from "../../shared/utils/type-utils";


@Component({
    selector: 'db-inactive-website-troubleshoot',
    templateUrl: './inactive-website-troubleshoot.component.html',
    styleUrls: ['./inactive-website-troubleshoot.component.scss'],
    standalone: false
})
export class InactiveWebsiteTroubleshootComponent extends DialogComponent<null, boolean> implements OnInit, AfterViewInit {

  public changes: any;
  public videoElement: any;
  public radius: any;
  public radiusForWatched: number = 0;
  public hideBackground: boolean;
  public managerLink: string;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
    super(
      _dialogService
    );
  }



  public close_window(): void {
    this.close();
  }
  ngOnInit(): void {
    this.radius = 2 * 3.14 * 5;

    this._store.select(fromStore.getTenWebProductsLoaded)
        .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => this._store.select(fromStore.getTenWebManagerPlugin)),
            first()
        ).subscribe((managerPlugin) => {
      this.managerLink = managerPlugin && managerPlugin.downloadLink;
    });

  }

  ngAfterViewInit() {
    // this.videoElement = jQuery('.db-video_container video').get(0);
    // if (this.videoElement) {
    //   this.videoElement.ontimeupdate = (event) => {
    //     this.radiusForWatched = this.videoElement.currentTime / this.videoElement.duration * 100;
    //   };
    // }
    // this.playVideo();
  }


  public playVideo(): void {
    // const video = <HTMLMediaElement>jQuery('.db-video_container video').get(0);
    // if (video) {
    //   setTimeout( () => {
    //     jQuery('.db-video_container video').show();
    //     this.hideBackground = true;
    //     if (video) {
    //       video.play();
    //     }
    //   }, 1000);
    // }
  }

  public downloadManagerPluginEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: '10Web Manager Download',
      eventLabel: TypeUtils.isDefined(this._router) && TypeUtils.isDefined(this._router.url) ? this._router.url : 'inactive-website-troubleshoot'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

}
